// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoBlock_wrapper","icon":"InfoBlock_icon","info":"InfoBlock_info","title":"InfoBlock_title","description":"InfoBlock_description"};